export const BASE_URL =
  process.env.REACT_APP_NODE_ENV === 'development' ? process.env.REACT_APP_PROXY_URL : process.env.REACT_APP_HOST;
export const TIME_OUT = 30000;
